module.exports = __webpack_public_path__ + "static/media/ultimatum-game-offers.1d1fa7a1.png";